import styled from 'styled-components'

export const OrderListStyle = styled.div``
